const ALGOLIA_FACET_CONDITION_LABEL_OVERRIDES = { "Shows Wear": "Very Good", Worn: "Good" };

document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook("beforeInstantSearchFacetParamsOptions", function (params, facet) {
    const isSoldItems = window.location.href.includes("sold-items");
    const baseParams = {
      ...params,
      showMore: true,
      showMoreLimit: 100,
    };
    if (facet.escapedName === "vendor" || facet.escapedName === "inventory_available") {
      return {
        ...baseParams,
        limit: 7,
        searchablePlaceholder: "Search",
        transformItems(items) {
          const facetSelector = `.ais-facet-${facet.escapedName}`;

          const facetElement = document.querySelector(facetSelector);
          if (facetElement) facetElement.style.display = items.length <= 1 ? "none" : "";
          return items;
        },
        templates: {
          item(item, { html }) {
            const { label, count } = item;
            // Customize the display for 'inventory_available' facet
            if (facet.escapedName === "inventory_available") {
              const displayLabel = label === "true" ? "Available Now" : "On Hold/Sold";
              return html`
                <label class="ais-RefinementList-label fp-font-weight--regular">
                  <input class="ais-RefinementList-checkbox" type="checkbox" value="${label}" />
                  <span class="ais-RefinementList-labelText">${displayLabel}</span>
                  <span class="ais-RefinementList-count">(${count})</span>
                </label>
              `;
            } else {
              // Default rendering for other facets (if any)
              return html`
                <label class="ais-RefinementList-label fp-font-weight--regular">
                  <input class="ais-RefinementList-checkbox" type="checkbox" value="${label}" />
                  <span class="ais-RefinementList-labelText">${label}</span>
                  <span class="ais-RefinementList-count">(${count})</span>
                </label>
              `;
            }
          },
        },
      };
    }

    if (facet.escapedName.includes("condition")) {
      return {
        ...baseParams,
        templates: {
          item(item, { html }) {
            const { label, count } = item;
            const displayLabel = ALGOLIA_FACET_CONDITION_LABEL_OVERRIDES[label] ?? label;
            return html`
              <label class="ais-RefinementList-label fp-font-weight--regular"
                ><input class="ais-RefinementList-checkbox" type="checkbox" value="${label}" /><span
                  class="ais-RefinementList-labelText"
                  >${displayLabel}</span
                ><span class="ais-RefinementList-count">(${count})</span></label
              >
            `;
          },
        },
      };
    }

    if (facet.escapedName === "meta.custom.hold_status") {
      return {
        ...baseParams,
        limit: 7,
        transformItems(items) {
          if (items.length > 1 && window.location.pathname === "/pages/following") {
            return items;
          } else {
            return [];
          }
        },
        templates: {
          item(item, { html }) {
            const { label, count } = item;
            return html`
              <label class="ais-RefinementList-label fp-font-weight--regular"
                ><input class="ais-RefinementList-checkbox" type="checkbox" value="${label}" /><span
                  class="ais-RefinementList-labelText"
                  >${label}</span
                ><span class="ais-RefinementList-count">(${count})</span></label
              >
            `;
          },
        },
      };
    }

    if (
      facet.escapedName === "meta.custom.filters_price_filters" ||
      facet.escapedName === "meta.custom.filters_locations"
    ) {
      return {
        ...baseParams,
        limit: 7,
        transformItems(items) {
          if (items.length > 1 && !isSoldItems) {
            return items;
          } else {
            return [];
          }
        },
        templates: {
          item(item, { html }) {
            const { label, count } = item;
            const currency = window.algoliaShopify.helpers.activeCurrencyCode();
            const internationalizedLabel = currency === "gbp" ? label.replaceAll("$", "£") : label;
            return html`
              <label class="ais-RefinementList-label fp-font-weight--regular"
                ><input class="ais-RefinementList-checkbox" type="checkbox" value="${label}" /><span
                  class="ais-RefinementList-labelText"
                  >${internationalizedLabel}</span
                ><span class="ais-RefinementList-count">(${count})</span></label
              >
            `;
          },
        },
      };
    }

    return {
      ...baseParams,
      limit: 7,
      templates: {
        item(item, { html }) {
          const { label, count } = item;
          const currency = window.algoliaShopify.helpers.activeCurrencyCode();
          const internationalizedLabel = currency === "gbp" ? label.replaceAll("$", "£") : label;
          return html`
            <label class="ais-RefinementList-label fp-font-weight--regular"
              ><input class="ais-RefinementList-checkbox" type="checkbox" value="${label}" /><span
                class="ais-RefinementList-labelText"
                >${internationalizedLabel}</span
              ><span class="ais-RefinementList-count">(${count})</span></label
            >
          `;
        },
      },
    };
  });
});
